import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard.vue'
import Logout from './views/Logout.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
        title: 'EA Digital Asset Manager - Dashboard'
      }
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "login" */ './views/Login.vue'),
      meta: {
        title: 'EA Digital Asset Manager - Login'
      }
    },
    {
      path: '/media',
      name: 'media',
      component: () => import( /* webpackChunkName: "media" */ './views/Media.vue'),
      meta: {
        requiresAuth: true,
        title: 'EA Digital Asset Manager - Media'
      }
    },
    {
      path: '/media/:media/:page?',
      name: 'media-create',
      component: () => import( /* webpackChunkName: "upload" */ './views/MediaUpload.vue'),
      meta: {
        requiresAuth: true,
        title: 'EA Digital Asset Manager - Media'
      }
    },
    {
      path: '/chargers',
      name: 'chargers',
      component: () => import( /* webpackChunkName: "chargers" */ './views/Chargers.vue'),
      meta: {
        requiresAuth: true,
        title: 'EA Digital Asset Manager - Chargers'
      }
    },
    {
      path: '/partners',
      name: 'partners',
      component: () => import( /* webpackChunkName: "partner-programs" */ './views/PartnerPrograms.vue'),
      meta: {
        requiresAuth: true,
        title: 'EA Digital Asset Manager - Partner Programs'
      }
    },
    {
      path: '/users',
      name: 'users',
      component: () => import( /* webpackChunkName: "users" */ './views/Users.vue'),
      meta: {
        requiresAuth: true,
        title: 'EA Digital Asset Manager - Users'
      }
    },
    {
      path: '/sky/:type',
      name: 'sky',
      component: () => import( /* webpackChunkName: "sky" */ './views/Sky.vue'),
      meta: {
        requiresAuth: true,
        title: 'EA Digital Asset Manager - Sky Objects'
      }
    },
    {
      path: '/sky/:type/:id/:page?',
      name: 'sky-edit',
      component: () => import( /* webpackChunkName: "sky-edit" */ './views/SkyEdit.vue'),
      meta: {
        requiresAuth: true,
        title: 'EA Digital Asset Manager - Sky Objects'
      }
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import( /* webpackChunkName: "reports" */ './views/Reports.vue'),
      meta: {
        requiresAuth: true,
        title: 'EA Digital Asset Manager - Reports'
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})